import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0;
`;

export const ActivityHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
  height: 36px;
`;

export const TabSwitcherContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const SearchArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-width: 0;

  & > button {
    white-space: nowrap;
  }
`;

/** Botón circular solo icono (Figma: búsqueda con borde gris) */
export const SearchIconButtonWrap = styled.div`
  display: inline-flex;
  border-radius: 50%;
  overflow: hidden;

  button {
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    padding: 0;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const SearchInputWrap = styled.div`
  min-width: 0;
  width: 100%;
  max-width: 280px;
`;

/* Search input inline (Figma): borde único, icono search, input, icono close dentro a la derecha */
export const SearchInputWrapper = styled.div`
  display: flex;
  height: 36px;
  padding: 4px 16px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background: #FFFFFF;
  border: 1px solid ${(props) => props.theme.colors?.border || '#D1D5DB'};
  border-radius: 8px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;

  &:focus-within {
    border-color: ${(props) => props.theme.colors?.primary || '#2563EB'};
    outline: none;
  }
`;

export const SearchIconLeft = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;

export const SearchInputWithClearWrap = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
`;

export const SearchInputField = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  padding: 0 28px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors?.text || '#111827'};
  box-sizing: border-box;

  &::placeholder {
    color: ${(props) => props.theme.colors?.textSecondary || '#9CA3AF'};
  }

  &:focus {
    outline: none;
  }
`;

export const SearchClearButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  border-radius: 50%;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;

  &:hover {
    color: ${(props) => props.theme.colors?.text || '#111827'};
    background-color: ${(props) => props.theme.colors?.border || '#E5E7EB'};
  }

  &:focus {
    outline: none;
  }
`;

export const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 24px 24px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${(props) => props.theme.colors?.border || '#E5E7EB'};
`;

export const PaginationInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const PaginationText = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;
